import { z } from 'zod'

export const AdminAccountSubscriptionFormSchema = z.object({
  subscriptionPlanId: z.string().min(1),
  startDate: z.string().min(1),
  endDate: z.string().min(1),
  price: z.coerce.number().min(0),
}).refine((values) => values.endDate > values.startDate, {
  message: 'End date must be after start date',
  path: ['endDate'],
})

export type AdminAccountSubscriptionFormValues = z.infer<typeof AdminAccountSubscriptionFormSchema>
